import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import b2b from '../views/b2b/store'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        'menus': 1,
        'money': '',
        'recruitScrollY': 0,
        'cachedInclude': ['goodsList'],
        'cachedExclude': [],
        'network': true
    },
    mutations,
    actions,
    modules: {
        b2b
    }
})
